import React from "react";
import { DatePicker } from "antd";

const MonthlyDatePicker = ({
  pickerType = "month",
  onChange,
  label,
  disabledDate,
  style,
  value,
}) => {
  return (
    <div style={{ marginBottom: "16px" }}>
      {label && <label style={{ marginBottom: "8px", display: "block" }}>{label}</label>}
      <DatePicker
        onChange={onChange}
        picker={pickerType}
        disabledDate={disabledDate}
        style={{
          width: "100%",
          height: "40px", 
          fontSize: "14px", 
          ...style,
        }}
        format="MMM, YYYY"
        value={value}
      />
    </div>
  );
};

export default MonthlyDatePicker;
